import dayjs from 'dayjs'
import { showItem } from './item/item.js'
import { executeCheck } from '../execute-check/index.js'

/*
I want to generate a list of months, with the different Tracking inside
show list of labels
and be able to
- listen to click to execute a call
- run programatically through all to run all

... update the item labels with the results
*/
export function showCheckItems (containerElementId, browserAppEntity) {
  console.log('showCheckItems', containerElementId, browserAppEntity)

  const containerElement = document.getElementById(containerElementId)
  if (!containerElement) return

  containerElement.innerHTML = htmlTemplate
  const thisElement = containerElement.querySelector('div')

  const listItems = []

  const numberMonths = 6

  for (let i = 0; i < numberMonths; i++) {
    const monthISO = dayjs().subtract(i, 'month').format('YYYY-MM')

    listItems.push({
      label: monthISO,
      status: 'pending',
      context: {
        monthISO
      }
    })

    if (browserAppEntity.data.trackings?.length > 0) {
      for (const tracking of browserAppEntity.data.trackings) {
        listItems.push({
          label: `${monthISO} => by ${tracking.name}`,
          status: 'pending',
          context: {
            monthISO,
            tracking
          }
        })
      }
    }
  }

  listItems.forEach(item => {
    const { Element } = showItem(thisElement, item, {
      onClick: async function (Element) {
        await executeItemCheck(item, Element, browserAppEntity)
      }
    })
    item.Element = Element
    item.executeCheck = async () => {
      await executeItemCheck(item, item.Element, browserAppEntity)
    }
  })

  console.log('listItems', listItems)

  return {
    listItems,
    runAllChecks: async () => {
      await runChecks(listItems)
    }
  }
}

async function executeItemCheck (item, Element, browserAppEntity) {
  Element.update({
    statusText: 'running',
    statusClass: 'is-info'
  })

  const checkResult = await executeCheck({
    accountingOrganisationId: browserAppEntity.data.accountingOrganisationId,
    monthISO: item.context.monthISO,
    numberMonths: 1,
    queryTrackings: item.context?.tracking ? [item.context.tracking.id] : []
  })
  // console.log('checkResult', checkResult)

  Element.update({
    statusText: `[${checkResult.summaryData.issueCode}] ${checkResult.summaryData.dataMatchCase}`,
    statusClass: checkResult.summaryData.issueCode < 10 ? 'is-success' : 'is-warning'
  })
}

async function runChecks (listItems) {
  for (const item of listItems) {
    console.log('runChecks', item)
    await item.executeCheck()
  }
}

const htmlTemplate = `
<div class="field is-grouped is-grouped-multiline">
</div>
`
